import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

export type TPendingServiceRequestAssignment = {
  id: string;
  country: string;
  countryName: string;
  purchasedAt: string;
  dueTodayUsd: number;
  lineItems: { name: string; billing: string; totalUsd: number }[];
};

export type TPendingAssignmentCompany = {
  id: number;
  displayName: string | null;
  entityCount: number;
};

type PendingAssignmentsResponse = {
  pendingAssignments: TPendingServiceRequestAssignment[];
  companies: TPendingAssignmentCompany[];
};

/**
 * Paid website self-serve incorporation purchases (matched on the logged-in
 * user's email) that still need to be attached to a company.
 */
export const usePendingServiceRequestAssignments = (options?: {
  enabled?: boolean;
}) => {
  const enabled = options?.enabled ?? true;

  const { data, error, mutate, isLoading } = useSWR<PendingAssignmentsResponse>(
    enabled ? 'self-serve-incorporation/pending-assignments' : null,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    )
  );

  return {
    pendingAssignments: data?.pendingAssignments ?? [],
    companies: data?.companies ?? [],
    error,
    mutate,
    isLoading: !!isLoading,
  };
};
